<template>
  <div class="speed-share">
    <div class="loading-wrap" v-if="isLoading">
      <img :src="loadingGif" />
    </div>
    <Nav subNav="小宝驿站" :isShowBack="1"></Nav>
    <div class="device-tabs" v-if="false">
      <div class="list-wrap">
        <div class="list-wrap-hr"></div>
        <div
          class="arrow-left arrow"
          @click="arrowLeftClick"
          v-if="list.length > 4"
        ></div>
        <div
          class="arrow-right arrow"
          @click="arrowRightClick"
          v-if="list.length > 4"
        ></div>
        <div :class="{ list: true, nopadding: list.length < 5 }" id="list">
          <div
            v-for="(item, index) in list"
            v-bind:key="item.peerid"
            class="item"
            :class="currentClickClass(index)"
            @click="tabsClick(index, item.peerid, item)"
          >
            <div :class="activeClass(index)">
              <div class="bgBlack"></div>
            </div>
            <div class="device-bind-wrap">
              <div class="device-status-wrap">
                <div
                  :class="{
                    'device-icon': true,
                    'device-icon-off': item.term.status == 1,
                  }"
                >
                  <div
                    :class="{
                      'device-status': true,
                      'device-status-off': item.term.status == 1,
                    }"
                  >
                    <div v-if="item.term.status == 1">离线</div>
                    <div v-else>在线</div>
                  </div>
                </div>
              </div>
              <div class="device-name-wrap">
                <div class="device-name">
                  {{
                    item.term.comment
                      ? item.term.comment
                      : item.term.name
                      ? item.term.name
                      : item.peerid
                  }}
                </div>
                <div class="device-ip">
                  IP：{{ item.ip ? $common.ipConvert(item.ip) : "" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoBindAlert v-if="isNoBind"></NoBindAlert>
    <div v-show="!isNoBind">
      <div v-show="!guideStepFlag">
        <div class="tip-text" v-if="tipText">{{ tipText }}</div>
        <div v-if="isLoading" class="install-wrap"></div>
        <div
          :class="{
            'content-wrap': true,
            'content-normal-wrap': modeType == modeTypeNormal,
          }"
          v-show="isReadXbjfXieyi == 1 && xbjf == 1 && !isLoading"
        >
          <!--					<div class="go_mall_wrap" @click="goExchangeClick">-->
          <!--						<div class="go_mall_icon"></div>-->
          <!--						<div class="go_mall_text">去商城</div>-->
          <!--					</div>-->
          <div class="text-wrap">
            <!-- <div class="text-icon"></div> -->
            <div class="text-title">小宝驿站正在营业</div>
            <div>本服务不会影响您看视频、玩游戏或购物等上网体验</div>
          </div>
          <div class="new-wrap">
            <div class="blank-panel"></div>
            <div class="speed-info-wrap" v-show="!isUnsupportSpeed">
              <div
                class="offline"
                v-show="peerItem && peerItem.term && peerItem.term.status"
              >
                <div class="offline_title">该设备已离线</div>
                <div class="offline_icon"></div>
              </div>
              <div v-show="!peerItem.term.status">
                <div v-show="modeType == 1">
                  <div class="mode_title">小宝驿站信息</div>
                  <div class="info-wrap">
                    <div class="device-bind-wrap">
                      <div class="device-status-wrap">
                        <div
                          :class="{
                            'device-icon': true,
                            'device-icon-off': peerItem.term.status == 1,
                          }"
                        >
                          <div
                            :class="{
                              'device-status': true,
                              'device-status-off': peerItem.term.status == 1,
                            }"
                          >
                            <div v-if="peerItem.term.status == 1">离线</div>
                            <div v-else>在线</div>
                          </div>
                        </div>
                      </div>
                      <div class="device-name-wrap">
                        <div class="device-name">
                          {{
                            peerItem.term.comment
                              ? peerItem.term.comment
                              : peerItem.term.name
                              ? peerItem.term.name
                              : peerItem.peerid
                          }}
                        </div>
                        <div class="device-ip">
                          IP：{{
                            peerItem.ip ? $common.ipConvert(peerItem.ip) : ""
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="info-line"></div>
                    <div class="info-status">
                      <div class="status-title">驿站经营状况</div>
                      <div
                        class="status-value"
                        :class="{
                          'status-value1': pointsStatus == 1,
                          'status-value2': pointsStatus == 2,
                          'status-value3': pointsStatus == 3,
                        }"
                      >
                        {{ pointsStatusText }}
                      </div>
                    </div>
                  </div>
                  <div class="points_wrap">
                    <div class="points_item points_item_all">
                      <div class="points_info">
                        <div class="points_title">
                          <div class="points_icon"></div>
                          驿站积分
                        </div>
                        <div class="points_value">
                          <font>{{ left_points }}</font>
                        </div>
                      </div>
                    </div>
                    <div class="points_item_line"></div>
                    <div class="points_item points_item_yesterday">
                      <div class="points_info">
                        <div class="points_title">
                          <div class="points_icon"></div>
                          昨日积分
                        </div>
                        <div class="points_value">
                          <font>{{ yesterday_points }}</font>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mode_title mode_title_points">设备积分趋势</div>
                  <div class="chart-wrap">
                    <div class="date-text1">
                      {{ dateText1 }}
                    </div>
                    <div class="date-text2">
                      {{ dateText2 }}
                    </div>
                    <div
                      id="test"
                      style="
                        width: 300px;
                        height: 150px;
                        margin-bottom: 10px;
                        margin-top: 10px;
                        margin-left: 50px;
                      "
                    ></div>
                  </div>
                </div>
                <!-- <div
									class="go_mall_btn2"
									@click="goExchangeClick"
								>
									小宝商城
								</div> -->
                <div class="points-btns">
                  <div class="rules" @click="showRuleAlert">驿站介绍</div>

                  <div class="rules" @click="showSetting">驿站管理</div>
                </div>
                <div class="unsupport_wrap" v-if="false">
                  <div class="unsupport_icon"></div>
                  <div class="unsupport_desc">
                    当前设备不支持小宝驿站收益模式<br />可重新检测是否能开启收益模式
                  </div>
                  <div class="unsupport_retest_btn">重新检测</div>
                </div>
                <div class="info-title" v-if="false">
                  <div></div>
                  <div>其他</div>
                </div>
                <div class="info-content" v-if="false">
                  <span
                    class="btn1"
                    :class="{ active: active == 1 }"
                    @click="showDescAlert"
                    >查看介绍</span
                  >
                  <span
                    class="btn2"
                    :class="{ active: active == 2 }"
                    @click="showOrHideModeTipClick('show')"
                    >模式设置</span
                  >
                </div>

                <div class="info-title" v-if="pidInfo.cid != 126 && false">
                  <div></div>
                  <div>共享资源缓存路径</div>
                </div>
                <div class="path-wrap-wrap" v-if="pidInfo.cid != 126 && false">
                  <div class="path-wrap">
                    <div class="path-text">
                      {{ cachedir }}
                    </div>
                  </div>
                  <div class="path-btn" @click="showPathAlert">修改</div>
                </div>

                <div class="path-tips" v-if="false">暂不支持修改缓存路径</div>
              </div>

              <!--							<div class="show-desc-btn" @click="showDescAlert">-->
              <!--								<div class="show-desc-icon"></div>-->
              <!--								<div class="show-desc-text">小宝驿站介绍</div>-->
              <!--							</div>-->
            </div>
            <div class="speed-info-wrap" v-show="isUnsupportSpeed">
              <div class="unsupport_wrap">
                <div class="unsupport_icon"></div>
                <div class="unsupport_desc">当前设备不支持小宝驿站收益模式</div>
              </div>
            </div>
          </div>

          <div class="normal-desc-wrap">
            <div class="desc-text"></div>
            <div
              class="desc-btn-tips"
              v-if="!(peerItem && peerItem.term && peerItem.term.status)"
            >
              不影响您的观影、购物或游戏等上网体验
            </div>
            <div
              class="desc-btn"
              @click="onChangeModeClick"
              v-if="!(peerItem && peerItem.term && peerItem.term.status)"
            >
              立即开启
            </div>
          </div>

          <div class="coin-wrap">
            <div class="coin_enter"></div>
            <div class="coin_bottom"></div>
            <div class="coin_bottom_coin"></div>
            <div class="coin_bottom_ticket"></div>
            <!-- 动画1：不透明度渐变-->
            <!-- 动画2：罐子长高-->
            <div
              :class="{
                coin_border: true,
                coin_border_normal: !isShowContainAnimation,
                coin_border_animation: isShowContainAnimation,
              }"
            ></div>
            <!-- 动画2：向左移动-->
            <div
              :class="{
                coin_bottom_left: true,
                coin_bottom_left_once: isShowContainAnimation,
              }"
            ></div>
            <!-- 动画2：向右移动-->
            <div
              :class="{
                coin_bottom_right: true,
                coin_bottom_right_once: isShowContainAnimation,
              }"
            ></div>

            <div class="coin_bottom_coins"></div>

            <!-- 动画2：金币翻转并落下-->
            <div
              :class="{
                coin_contain_coin: true,
                coin_contain_coin_animation: isShowContainAnimation,
              }"
            ></div>

            <!-- 动画2：另一个金币翻转并落下-->
            <div
              :class="{
                coin_contain_coin_02: true,
                coin_contain_coin_02_animation: isShowContainAnimation,
              }"
            ></div>

            <!-- 动画2：另一个金币翻转并落下-->
            <div
              :class="{
                coin_contain_coin_03: true,
                coin_contain_coin_03_animation: isShowContainAnimation,
              }"
            ></div>

            <!-- 动画2：另一个金币翻转并落下-->
            <div
              :class="{
                coin_contain_coin_04: true,
                coin_contain_coin_04_animation: isShowContainAnimation,
              }"
            ></div>

            <!-- 动画1：普通高光-->
            <!-- 动画2：会员高光-->
            <div
              :class="{
                coin_border_left: true,
                coin_border_right_normal: !isShowContainAnimation,
                coin_border_right_animation: isShowContainAnimation,
              }"
            ></div>

            <!-- 动画1：普通高光-->
            <!-- 动画2：会员高光-->
            <div
              :class="{
                coin_border_left_left: true,
                coin_border_right_normal: !isShowContainAnimation,
                coin_border_right_animation: isShowContainAnimation,
              }"
            ></div>

            <!-- 动画1：普通高光-->
            <!-- 动画2：会员高光-->
            <div
              :class="{
                coin_border_right: true,
                coin_border_right_normal: !isShowContainAnimation,
                coin_border_right_animation: isShowContainAnimation,
              }"
            ></div>

            <!-- 动画1：普通高光-->
            <!-- 动画2：会员高光-->
            <div
              :class="{
                coin_border_right_right: true,
                coin_border_right_normal: !isShowContainAnimation,
                coin_border_right_animation: isShowContainAnimation,
              }"
            ></div>
          </div>
        </div>
        <div
          v-show="isReadXbjfXieyi != 1 || xbjf != 1"
          :class="{ 'install-wrap': true }"
        >
          <div v-if="xbjf == -1">
            <div
              v-if="peerItem && peerItem.term && peerItem.term.status == 1"
              class="offline-wrap"
            >
              <div>设备已离线</div>
              <div class="offline-icon"></div>
            </div>
            <OpenAlert
              @onCloseClick="goBack"
              @onSureClick="installXbjfClick"
              v-else
            ></OpenAlert>
            <!-- <div v-else class="install">
              <div class="text1">应用未开启</div>
              <div class="icon1"></div>
              <div class="text2">当前设备暂未开启小宝驿站应用</div>
              <div class="btn-wrap">
                <div class="btn1" @click="goBack">取消</div>
                <div class="btn2" @click="installXbjfClick">立即开启</div>
              </div>
            </div> -->
          </div>

          <div v-else-if="xbjf == 6" class="install install2">
            <div class="icon1"></div>
            <div class="text2">正在开启小宝驿站应用</div>
            <div class="speedshare-installing-btn" v-if="xbjf == 6">
              <div class="text">开启中...</div>
              <el-progress
                :text-inside="true"
                :stroke-width="41"
                :percentage="xbjfPercent"
                color="#6BB3F6"
              ></el-progress>
            </div>
          </div>

          <div class="install" v-else-if="isReadXbjfXieyi == 0">
            <div class="back-wrap" @click="goBack">
              <div class="back-text">返回</div>
            </div>
            <div class="text1">欢迎使用小宝驿站</div>
            <!-- <div class="icon1"></div> -->
            <div class="xcbf-content">
              <div class="content-item">驿站租用闲置空间，赚取积分收益</div>
              <div class="content-item">不影响网络冲浪、购物等体验</div>
              <div class="content-item">积分可兑换电话卡或各类VIP会员</div>
            </div>
            <div class="xieyi-wrap" @click="checkXieyiClick">
              <div
                :class="{
                  xieyi: true,
                  'red-xieyi': isShowRedXieyi,
                }"
              >
                <div
                  :class="{
                    icon2: true,
                    icon3: isCheckXieyi,
                  }"
                ></div>
                我已阅读并同意
                <span
                  @click.stop="
                    openUrl('https://www.ionewu.com/XbjfUserProtocol.html')
                  "
                  >《服务协议》</span
                >及
                <span
                  @click.stop="
                    openUrl('https://www.ionewu.com/XbjfPrivacyProtocol.html')
                  "
                  >《隐私政策》</span
                >
              </div>
            </div>
            <div class="btns">
              <div class="cancel-btn" @click="goBack">取消</div>
              <div class="open-btn" @click="openClick">开启</div>
            </div>
          </div>
        </div>
        <SpeedMessageTip
          v-if="messageFlag"
          :cacheused="cacheused"
          :openSpeedFlag="openSpeedFlag"
          :messageType="messageType"
          @clearCacheClick="clearCacheClick"
          @closeMessageAlertClick="closeMessageAlertClick"
          @closeOrOpenSpeedClick="closeOrOpenSpeedClick"
          @cacheCleanClick="cacheCleanClick"
        ></SpeedMessageTip>
        <PointsRulesTip
          v-if="pointsRulesFlag"
          @showOrHideRulesTipClick="showOrHideRulesTipClick"
        ></PointsRulesTip>
        <ModeTip
          v-if="modeFlag"
          @showOrHideModeTipClick="showOrHideModeTipClick"
          @modeSaveClick="modeSaveClick"
          :diskcache="diskcache"
          :uploadspeed="uploadspeed"
          :switching="switching"
        ></ModeTip>
      </div>
      <Guide v-show="guideStepFlag == 2" @speedClick="speedClick"> </Guide>
    </div>
    <PathAlert @close="hidePathAlert" v-if="isShowPathAlert"></PathAlert>
    <JfRuleAlert @close="hideRuleAlert" v-if="isShowRuleAlert"></JfRuleAlert>
    <SpeedShareMessage
      :messageType="messageType2"
      v-if="isShowMessage"
    ></SpeedShareMessage>
    <ChangeModeAlert
      :modeType="modeType"
      v-if="isShowChangeModeAlert"
      @onCancelClick="hideChangeModeAlert"
      @onSureClick="changeMode"
    ></ChangeModeAlert>
    <UnsupportSpeedAlert
      v-if="isShowUnsupportSpeedAlert"
      @onCancelClick="hideUnsupportSpeedAlert"
      @onReTestClick="onReTestClick"
    ></UnsupportSpeedAlert>
    <ChangeSpeedSuccessAlert
      v-if="isShowChangeSpeedSuccessAlert"
      @onCancelClick="hideChangeSpeedSuccessAlert"
      @onSureClick="hideChangeSpeedSuccessAlert"
    ></ChangeSpeedSuccessAlert>
    <Setting
      :pid="peerid"
      @onCloseClick="hideSetting"
      @updateSetting="init"
      v-if="isShowSetting"
    ></Setting>

    <IframeAlert :url="url" @close="closeUrl" v-if="url"></IframeAlert>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { mapActions } from "vuex";
import SpeedMessageTip from "@/components/SpeedMessageTip.vue";
import NoBindAlert from "@/components/NoBindAlert.vue";
import PathAlert from "@/components/PathAlert.vue";
import JfRuleAlert from "@/components/JfRuleAlert.vue";
import PointsRulesTip from "@/components/PointsRulesTip.vue";
import ModeTip from "@/components/ModeTip.vue";
import SpeedShareMessage from "./SpeedShareMessage.vue";
import Nav from "@/components/Common/Nav.vue";
import ChangeModeAlert from "@/components/Speed/ChangeModeAlert.vue";
import UnsupportSpeedAlert from "@/components/Speed/UnsupportSpeedAlert.vue";
import ChangeSpeedSuccessAlert from "@/components/Speed/ChangeSpeedSuccessAlert.vue";
import Guide from "@/components/Speed/Guide.vue";
import Setting from "@/components/Speed/Setting.vue";
import IframeAlert from "@/components/IframeAlert.vue";
import OpenAlert from "@/components/Speed/OpenAlert.vue";

export default {
  name: "SpeedShare",
  components: {
    SpeedMessageTip,
    NoBindAlert,
    PathAlert,
    JfRuleAlert,
    PointsRulesTip,
    ModeTip,
    SpeedShareMessage,
    Nav,
    ChangeModeAlert,
    UnsupportSpeedAlert,
    Guide,
    ChangeSpeedSuccessAlert,
    IframeAlert,
    Setting,
    OpenAlert,
  },
  data: function () {
    return {
      isLoading: false,
      loadingGif: require("../assets/home/node/loading.gif"),
      cur_pid: this.$route.params.cur_pid ? this.$route.params.cur_pid : "",
      action: this.$route.params.action ? this.$route.params.action : "",
      messageType2: 1,
      pidInfo: {
        cid: 0,
        did: 0,
      },

      isShowSetting: false,
      isShowMessage: false,
      isShowRuleAlert: false,
      isShowPathAlert: false,
      isShowChangeModeAlert: false,
      isShowUnsupportSpeedAlert: false,
      isShowChangeSpeedSuccessAlert: false,
      isUnsupportSpeed: false,
      isNoBind: false,
      messageFlag: false, //true显示弹框，false不显示
      messageType: "", //弹框类型：清除缓存弹框（showClearCache）
      currentTab: 0,
      list: [], //设备列表
      peerid: "",
      peerItem: {
        term: {},
      },
      upSpeedBtnFlag: null,
      cacheBtnFlag: null, //1显示左边的缓存按钮，2显示中间的缓存按钮，3显示右边的缓存按钮
      guideStepFlag: null, //null不显示视频加速指引，2显示共享带宽指引
      isShowContainAnimation: false,
      total_points: 0, //总积分
      left_points: 0, //剩余积分
      yesterday_points: 0, //昨日积分
      pointsArray: [], //每日积分
      cachedir: "", //缓存路径
      share_switch: "on", //on或者off
      cacheused: 0, //缓存占用
      diskcache: 0, // 缓存设置
      uploadspeed: 0, //上传限速
      switching: 0, //关闭加速1 开启加速0
      openSpeedFlag: null, //关闭加速1 开启加速0
      dateText1: "",
      dateText2: "",
      tipText: "",
      active: 0, //0表示没有点击"查看介绍按钮"和"模式设置按钮"，1表示点击"查看介绍按钮"，2表示点击"模式设置按钮"
      pointsRulesFlag: false,
      modeFlag: false,
      modeType: 1, // 1 收益模式 2 均衡 3 普通
      modeTypeNormal: 3,
      modeTypeSpeed: 1,
      bonus: 0,
      bonusStr: "",
      xbjf: 1, //已安装1 未安装-1安装又卸载了0   6安装中	8安装成功
      isReadXbjfXieyi: 1, //1已读 0未读
      xbjfPercent: 0,
      isCheckXieyi: false,
      isShowRedXieyi: false,
      url: "",
      nat: 0,
      upnp: 0,
    };
  },
  methods: {
    ...mapActions([
      "bindget",
      "readguideget",
      "readguideset",
      "points",
      "deviceInfo",
      "limitget",
      "limitset",
      "cacheclean",
      "sendUserlog",
      "userGrowthInfo",
      "miniappList",
      "miniappStatus",
      "miniappAgree",
      "getUserInfo",
      "nodeDeviceInfo",
    ]),
    init: function () {
      let _that = this;
      _that.cur_pid = this.$route.params.cur_pid
        ? this.$route.params.cur_pid
        : this.$store.state.curDev
        ? this.$store.state.curDev.peerid
        : "";
      _that.action = this.$route.params.action ? this.$route.params.action : "";
      // console.log("this.$route.params", this.$route.params);
      _that.myBindget();
      _that.getlimitget();
    },
    goBack: function () {
      this.$router.back(-1);
    },
    showSetting: function () {
      this.isShowSetting = true;
    },
    hideSetting: function () {
      this.isShowSetting = false;
    },
    openUrl: function (url) {
      let _that = this;
      _that.url = url;
    },
    closeUrl: function () {
      let _that = this;
      _that.url = "";
    },
    backToApplicationsClick: function () {
      let _that = this;
      // console.log(_that.peerid);
      _that.$router.push({
        name: "applications",
        params: { cur_pid: _that.peerid },
      });
    },
    checkXieyiClick: function () {
      let _that = this;
      _that.isCheckXieyi = !_that.isCheckXieyi;
      if (_that.isCheckXieyi) {
        _that.isShowRedXieyi = false;
      }
    },
    openClick: function () {
      let _that = this;

      if (!_that.isCheckXieyi) {
        _that.isShowRedXieyi = true;
      } else {
        _that.miniappAgree([
          _that.peerid,
          "xbjf",
          function (err, data) {
            // 同意完协议更新设备设置
            _that.getlimitget(function () {
              _that.isReadXbjfXieyi = 1;
            });
          },
        ]);

        _that.modeSaveClick(1);
      }
    },
    installXbjfClick: function () {
      let _that = this;
      // _that.xbjf = 6;
      // _that.xbjfPercent = 5;
      // setTimeout(function () {
      //   _that.xbjfPercent = 15;
      // }, 500);
      // setTimeout(function () {
      //   _that.xbjfPercent = 90;
      // }, 1500);
      // setTimeout(function () {
      //   _that.xbjfPercent = 100;
      // }, 2500);
      // setTimeout(function () {
      //   _that.xbjf = 1;
      // }, 2800);

      _that.xbjf = 1;
      _that.isReadXbjfXieyi = 1;
      _that.isLoading = true;
      _that.miniappStatus([
        _that.peerid,
        "xbjf",
        1,
        function (err, data) {
          _that.isCheckXieyi = true;
          setTimeout(function () {
            _that.isLoading = false;
          }, 1000);
          _that.openClick();
        },
      ]);
    },
    showChangeSpeedSuccessAlert: function () {
      this.isShowChangeSpeedSuccessAlert = true;
    },
    hideChangeSpeedSuccessAlert: function () {
      this.isShowChangeSpeedSuccessAlert = false;
    },
    changeSpeedMode: function () {
      this.changeMode();
      this.showChangeSpeedSuccessAlert();
    },
    goNodeManageClick: function () {
      let _that = this;
      _that.$router.push("/home/node/manage");
    },
    hideChangeModeAlert: function () {
      this.isShowChangeModeAlert = false;
    },
    showChangeModeAlert: function () {
      this.isShowChangeModeAlert = true;
    },
    changeMode: function () {
      this.modeSaveClick(
        this.modeType == this.modeTypeNormal
          ? this.modeTypeSpeed
          : this.modeTypeNormal
      );
      this.hideChangeModeAlert();
    },
    onChangeModeClick: function () {
      this.showChangeModeAlert();

      // if (this.modeType != 1) {
      // 	this.changeSpeedMode();
      // } else {
      // 	this.showChangeModeAlert();
      // }
    },
    hideUnsupportSpeedAlert: function () {
      this.isShowUnsupportSpeedAlert = false;
    },
    showUnsupportSpeedAlert: function () {
      this.isShowUnsupportSpeedAlert = true;
    },
    onReTestClick: function () {
      this.hideUnsupportSpeedAlert();
    },
    onTabClick: function (tabType) {
      let _that = this;
      _that.sendUserlog([tabType + "_click", ""]);
    },
    activeClass: function (index) {
      let _that = this;
      let bgClass = "";
      if (_that.currentTab == index) {
        if (_that.currentTab == 0) {
          bgClass = "activeLeftBg";
        } else if (_that.currentTab == _that.list.length - 1) {
          bgClass = "activeRightBg";
        } else if (
          _that.currentTab > 0 &&
          _that.currentTab < _that.list.length - 1
        ) {
          bgClass = "activeMiddleBg";
        }
      }
      return bgClass;
    },
    showNodeManageClick: function () {
      let _that = this;
      _that.onTabClick("sbgl");
      _that.showNodeManageFlag = true;
      _that.isShowVipMessage = false;
    },
    onShowAboutClick: function () {
      let _that = this;
      _that.$store.state.view.isShowWyjTipsAlert = true;
    },
    currentClickClass: function (index) {
      let _that = this;
      return _that.currentTab == index ? "activeWrap" : "";
    },
    myUserGrowthInfo: function () {
      let _that = this;
      _that.userGrowthInfo([
        function (err, data) {
          if (data && data.rtn == 0) {
            if (data.data) {
              if (data.data.bouns != undefined) {
                _that.bonus = data.data.bouns * 100;
                if (_that.$store.state.user.vip_left > 0) {
                  if (_that.bouns == 0) {
                    _that.bonusStr = "绑定手机100成长值";
                  } else {
                    _that.bonusStr = "小宝VIP收益加成" + _that.bonus + "%";
                  }
                } else {
                  _that.bonusStr = "提升积分收益？小宝VIP来助力";
                }
              }
            }
          }
        },
      ]);
    },
    modeSaveClick: function (modeFlag) {
      let _that = this;
      let uploadspeed = 0;
      let diskcache = 0;
      let switching = 0;
      if (modeFlag == 1) {
        _that.sendUserlog(["open_xbjf", _that.peerid]);
        uploadspeed = 100;
        diskcache = 200;
      } else if (modeFlag == 2) {
        uploadspeed = 50;
        diskcache = 100;
      } else {
        _that.sendUserlog(["close_xbjf", _that.peerid]);
        switching = 1;
        uploadspeed = 10;
        diskcache = 50;
      }
      _that.limitset([
        _that.peerid,
        diskcache,
        uploadspeed,
        switching,
        null,
        function (err, data) {
          setTimeout(function () {
            _that.buildPointsArray();
          }, 1000);

          if (data && data.rtn == 0) {
            // _that.tipText = "设置成功";
            // setTimeout(function () {
            // 	_that.tipText = "";
            // }, 2000);
            if (switching == 0) {
              // _that.showChangeSpeedSuccessAlert();
            }
            _that.getlimitget();
          }
        },
      ]);
    },
    showOrHideModeTipClick: function (flag) {
      let _that = this;
      _that.active = 2;
      if (flag == "show") {
        _that.modeFlag = true;
      } else {
        _that.modeFlag = false;
        _that.active = 0;
      }
    },
    showOrHideRulesTipClick: function (flag) {
      let _that = this;
      _that.active = 1;
      if (flag == "show") {
        _that.pointsRulesFlag = true;
      } else {
        _that.pointsRulesFlag = false;
        _that.active = 0;
      }
    },
    showRuleAlert: function () {
      let _that = this;
      _that.isShowRuleAlert = true;
    },
    hideRuleAlert: function () {
      let _that = this;
      _that.isShowRuleAlert = false;
    },
    showPathAlert: function () {
      let _that = this;
      _that.isShowPathAlert = true;
    },
    hidePathAlert: function () {
      let _that = this;
      _that.isShowPathAlert = false;
    },
    showDescAlert: function () {
      let _that = this;
      _that.$store.state.view.isShowByTipsAlert = true;
    },
    saveClick: function () {
      let _that = this;
      let cacheset = 0;
      if (_that.cacheBtnFlag == 3) {
        cacheset = 200;
      } else if (_that.cacheBtnFlag == 2) {
        cacheset = 100;
      } else {
        cacheset = 50;
      }

      let upspeed = 0;
      if (_that.upSpeedBtnFlag == 3) {
        upspeed = 100;
      } else if (_that.upSpeedBtnFlag == 2) {
        upspeed = 50;
      } else {
        upspeed = 10;
      }

      _that.limitset([
        _that.peerid,
        cacheset,
        upspeed,
        null,
        null,
        function (err, data) {
          if (data && data.rtn == 0) {
            _that.tipText = "已保存";
            setTimeout(function () {
              _that.tipText = "";
            }, 2000);

            _that.getlimitget();
          }
        },
      ]);
    },
    getlimitget: function (cb) {
      let _that = this;
      _that.limitget([
        _that.peerid,
        function (err, data) {
          if (data && data.rtn == 0) {
            if (data.cachedir) {
              _that.cachedir = data.cachedir;
            } else {
              _that.cachedir = "";
            }
            //获取缓存大小
            if (data.diskcache) {
              _that.diskcache = data.diskcache;
            } else {
              _that.diskcache = 0;
            }
            if (data.cacheused) {
              _that.cacheused = data.cacheused;
            } else {
              _that.cacheused = 0;
            }
            //获取上传速度
            if (data.uploadspeed) {
              _that.uploadspeed = data.uploadspeed;
            } else {
              _that.uploadspeed = 0;
            }
            //switch 1关闭 0开启
            if (data.switch == 1) {
              _that.openSpeedFlag = 1;
              _that.cacheBtnFlag = null;
              _that.switching = 1;
              _that.xbjf = -1;
            } else {
              _that.switching = 0;
              _that.openSpeedFlag = 0;
              if (data.diskcache == 200) {
                _that.cacheBtnFlag = 3;
              } else if (data.diskcache == 100) {
                _that.cacheBtnFlag = 2;
              } else {
                _that.cacheBtnFlag = 1;
              }
              if (data.uploadspeed == 100) {
                _that.upSpeedBtnFlag = 3;
              } else if (data.uploadspeed == 50) {
                _that.upSpeedBtnFlag = 2;
              } else {
                _that.upSpeedBtnFlag = 1;
              }
            }
          }

          if (_that.switching == 1) {
            // 普通模式
            _that.modeType = 3;
          } else {
            _that.modeType = 1;
          }

          console.log("_that.modeType", _that.modeType);

          if (_that.cur_pid && _that.action == "open_speed") {
            // console.log("getlimit", _that.action, _that.modeType);
            if (_that.modeType == 3) {
              // _that.changeSpeedMode();
              _that.onChangeModeClick();
              _that.action = "";
            }
          }
          cb ? cb() : null;
        },
      ]);
    },
    showMessageClick: function (messageTypeFlag) {
      let _that = this;
      _that.messageFlag = true;
      _that.messageType = messageTypeFlag;
    },
    cacheCleanClick: function (percent) {
      let _that = this;
      _that.cacheclean([
        _that.peerid,
        percent,
        function (err, data) {
          if (data && data.rtn == 0) {
            _that.tipText = "已清空缓存";
            setTimeout(function () {
              _that.tipText = "";
            }, 2000);
          }
        },
      ]);
    },
    closeOrOpenSpeedClick: function (flag) {
      let _that = this;
      // console.log("flag", flag);
      // console.log("openSpeedFlag", _that.openSpeedFlag);
      // console.log("diskcache", _that.diskcache);
      // console.log("uploadspeed", _that.uploadspeed);
      let diskcache = _that.diskcache ? _that.diskcache : 200;
      let uploadspeed = _that.uploadspeed ? _that.uploadspeed : 100;
      if (flag == 0) {
        if (flag != _that.openSpeedFlag) {
          _that.sendUserlog(["open_xbjf", _that.peerid]);
          diskcache = 200;
          uploadspeed = 100;
        }
      } else if (flag == 1) {
        _that.sendUserlog(["close_xbjf", _that.peerid]);
        _that.openSpeedFlag = 1;
        _that.cacheBtnFlag = null;
        _that.upSpeedBtnFlag = null;
      }
      _that.limitset([
        _that.peerid,
        diskcache,
        uploadspeed,
        flag,
        null,
        function (err, data) {
          if (data && data.rtn == 0) {
            _that.tipText = "已保存";
            setTimeout(function () {
              _that.tipText = "";
            }, 2000);
            _that.getlimitget();
          }
        },
      ]);
    },
    clearCacheClick: function () {
      let _that = this;
      _that.sendUserlog(["clear_cache_click", _that.peerid]);
      _that.messageFlag = false;
      if (_that.openSpeedFlag == 0) {
        _that.tipText = "请关闭加速后再清理缓存";
        setTimeout(function () {
          _that.tipText = "";
        }, 2000);
      } else {
        _that.messageFlag = true;
        _that.messageType = "showClearCache";
      }
    },
    closeMessageAlertClick: function () {
      let _that = this;
      _that.messageFlag = false;
    },
    cacheLeftClick: function () {
      let _that = this;
      _that.cacheBtnFlag = 1;
    },
    cacheMiddleClick: function () {
      let _that = this;
      _that.cacheBtnFlag = 2;
    },
    cacheRightClick: function () {
      let _that = this;
      _that.cacheBtnFlag = 3;
    },
    upSpeedLeftClick: function () {
      let _that = this;
      _that.upSpeedBtnFlag = 1;
    },
    upSpeedMiddleClick: function () {
      let _that = this;
      _that.upSpeedBtnFlag = 2;
    },
    upSpeedRightClick: function () {
      let _that = this;
      _that.upSpeedBtnFlag = 3;
    },
    closeOrOpenShareClick: function (flag) {
      let _that = this;
      _that.limitset([
        _that.peerid,
        _that.diskcache,
        null,
        null,
        flag,
        function (err, data) {
          if (data && data.rtn == 0) {
            _that.limitget([
              _that.peerid,
              function (err, data) {
                if (data && data.rtn == 0) {
                  if (data.share_switch) {
                    _that.share_switch = data.share_switch;
                  }
                }
              },
            ]);
          }
        },
      ]);
    },
    goVipClick: function () {
      let _that = this;
      _that.sendUserlog(["go_vip_click", ""]);
      _that.$router.push({ path: "/home/vip" });
    },
    goExchangeClick: function () {
      let _that = this;
      _that.sendUserlog(["setting_exchange_click", ""]);
      _that.$router.push({ path: "/home/mall" });
    },
    backClick: function () {
      let _that = this;
      _that.$router.push({ path: "/home/speedtabs" });
    },
    speedClick: function () {
      let _that = this;
      //已读指引
      // _that.guideStepFlag = 2;

      _that.readguideset([
        function (err, data) {
          _that.guideStepFlag = null;
        },
      ]);

      setTimeout(function () {}, 2000);
    },
    arrowLeftClick: function () {
      let ele = document.getElementById("list");
      ele.scrollLeft = ele.scrollLeft - 90;
    },
    arrowRightClick: function () {
      let ele = document.getElementById("list");
      ele.scrollLeft = ele.scrollLeft + 90;
    },
    tabsClickClass: function (index) {
      let _that = this;
      return _that.currentTab == index ? "tabsItemActive" : "";
    },
    tabsClick: function (index, peerid, item) {
      // console.log("tabsClick", index, peerid, item);
      let _that = this;
      _that.currentTab = index;
      _that.peerid = peerid;
      _that.peerItem = item;
      // console.log("_that.peerItem", _that.peerItem);

      _that.getMiniappList(_that.peerid);
    },
    draw1: function (d, p) {
      let ele = document.getElementById("test");
      if (!ele) {
        return;
      }
      var myChart = echarts.init(ele);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: "cross",
          //   label: {
          //     backgroundColor: "#6a7985",
          //   },
          // },
        },
        legend: {
          show: true,
          top: 0,
          left: 0,
        },
        toolbox: {
          feature: {
            saveAsImage: { show: false },
          },
        },
        grid: {
          left: "2%",
          right: "4%",
          bottom: "3%",
          top: "18%",
          containLabel: true,
          show: true,
          // backgroundColor:'#FBFBFB',
          borderColor: "transparent",
        },

        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: d,
            axisTick: {
              show: true,
            },
            axisPointer: {
              type: "none", //line或者none
            },
            axisLabel: {
              fontWeight: "normal",
              align: "left",
              verticalAlign: "middle",
              padding: [25, 0, 0, 0],
              color: "transparent",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "transparent",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisPointer: {
              type: "none",
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              fontWeight: "normal",
              color: "rgba(203, 203, 203, 1)",
            },
          },
        ],
        series: [
          {
            name: "积分",
            type: "line",
            stack: "总量",
            // areaStyle: {
            //   color: "#transparent",
            // },
            itemStyle: {
              normal: {
                // color: "#8B61ED",
              },
            },
            lineStyle: {
              color: "#F0AF2D", // 0% 处的颜色
              width: 1,
            },
            emphasis: {
              focus: "series",
              lineStyle: {
                width: 1,
              },
            },
            data: p,
            smooth: true,
            symbol:
              "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAAXNSR0IArs4c6QAAAEVQTFRFAAAA//8A/58g/6oc7qoq760p960p97Up76co8awp8bMp86wq87Iq87Iv8K0p8K8t8Kwr8K8r8K8s8a8t8K8t8a8s8K8tlcCNKwAAABZ0Uk5TAAEICR4fHx8gJSUrKysyM1NTv8L1+DSuss0AAABzSURBVBgZBcEBEoIwEASw3LYojv//Kx3kalKQfMq++kFRxwew1jbUeQLM/AyvE4DhN8YXNWeqNvOeQc2otCZ5I4EEZ4IAQQIFbMiDBhqdhW7oxpqN1ql+NnrsfbB3Pw3XPXQNAPcyePoAXGsrGHlHX934A1bfNDN87smJAAAAAElFTkSuQmCC",
            showSymbol: false,
            symbolSize: 13,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    myBindget: function () {
      let _that = this;
      _that.isLoading = true;
      _that.bindget([
        function (err, data) {
          if (data && !data.rtn) {
            //rtn等于0时，后台不返回此字段
            if (data && !data.rtn) {
              //rtn等于0时，后台不返回此字段
              if (data && data.terms && data.terms.length > 0) {
                _that.isNoBind = false;
              } else {
                _that.isNoBind = true;
              }
            } else {
              _that.isNoBind = true;
            }

            if (data && data.terms && data.terms.length > 0) {
              _that.list = data.terms;

              for (let index = 0; index < _that.list.length; index++) {
                const element = _that.list[index];
                // for test
                // element.term.status = 1;
                // 构造ip mac 信息
                element.ip = "";
                element.mac = "";

                if (element.term && !element.term.name) {
                  let pidInfo = _that.$common.getInfoByPid(element.peerid);
                  element.term.name = pidInfo.cname + pidInfo.dname;
                }

                if (element.term && element.term.nic) {
                  let nic = _that.$common.getNicByNics(element.term.nic);
                  if (nic) {
                    element.ip = nic.ipv4n;
                    element.mac = nic.mac;
                  }
                }
                if (element.term && element.term.comment) {
                  if (element.term.comment == "0") {
                    element.term.comment = "";
                  }
                }
              }

              //默认显示第一个设备的远程服务列表
              let peerid = data.terms[0].peerid;
              let peerItem = data.terms[0];
              let peerIndex = 0;
              if (_that.cur_pid) {
                for (let index = 0; index < _that.list.length; index++) {
                  const element = _that.list[index];
                  if (_that.cur_pid == element.peerid) {
                    peerid = element.peerid;
                    peerItem = element;
                    peerIndex = index;
                    break;
                  }
                }
              }
              // console.log("peerItem", peerItem);
              _that.peerid = peerid;
              _that.peerItem = peerItem;
              _that.currentTab = peerIndex;

              console.log(_that.peerItem);

              _that.getMiniappList(_that.peerid);
              _that.buildPointsArray();
            }
          }
        },
      ]);
    },
    getMiniappList: function () {
      let _that = this;
      _that.isLoading = true;
      _that.miniappList([
        _that.peerid,
        function (err, data) {
          _that.isLoading = false;
          if (!err && data && data.rtn == 0) {
            if (!data.xbjf) {
              _that.xbjf = -1;
            } else {
              _that.xbjf = data.xbjf;
            }

            if (data.data[1].agree == 1) {
              _that.isReadXbjfXieyi = 1;
            } else {
              _that.isReadXbjfXieyi = 0;
            }
          }
        },
      ]);
    },
    buildPointsArray: function () {
      let _that = this;
      let newval = _that.pointsArray;
      let d = [];
      let p = [];
      if (newval && newval.length > 0) {
        for (let i = newval.length - 1; i > -1; i--) {
          let long_date = newval[i].long_date;
          let long_date1 = long_date.replace("-", ".").replace("-", ".");
          d.push(long_date1);
          p.push(newval[i].points);
          if (i == newval.length - 1) {
            _that.dateText1 = long_date1;
          }
          if (i == 0) {
            _that.dateText2 = long_date1;
          }
        }
      }
      _that.draw1(d, p);
    },
  },
  computed: {
    pointsStatus: function () {
      if (this.nat && this.upnp) {
        return 3;
      } else if (this.nat || this.upnp) {
        return 2;
      } else {
        return 1;
      }
    },
    pointsStatusText: function () {
      if (this.pointsStatus == 3) {
        return "好";
      } else if (this.pointsStatus == 3) {
        return "中";
      } else {
        return "差";
      }
    },
  },
  watch: {
    peerid: function (newval) {
      // console.log("peerid", newval);
      let _that = this;
      if (newval) {
        //获取每日积分
        _that.points([
          _that.peerid,
          function (err, data) {
            if (data && data.rtn == 0 && data.data && data.data.length > 0) {
              _that.pointsArray = data.data;
              _that.yesterday_points = _that.pointsArray[0].points;
            } else {
              _that.pointsArray = [];
              _that.yesterday_points = 0;
            }
            _that.buildPointsArray();
          },
        ]);
        //获取总积分
        _that.deviceInfo([
          _that.peerid,
          function (err, data) {
            if (data && data.rtn == 0) {
              if (data.data.total_points) {
                _that.total_points = data.data.total_points;
              }
            }
          },
        ]);

        //获取总积分
        _that.left_points = 0;
        let reqData = {
          uid: _that.$store.state.user.uid,
        };
        _that.getUserInfo([
          reqData,
          function (err, data) {
            if (data && data.rtn == 0) {
              if (data.data.left_points) {
                _that.left_points = data.data.left_points;
              }
            }
          },
        ]);

        _that.nodeDeviceInfo([
          _that.peerid,
          function (err, data) {
            if (data.data.nat != undefined) {
              _that.nat = data.data.nat;
            }
            if (data.data.upnp != undefined) {
              _that.upnp = data.data.upnp;
            }
          },
        ]);

        _that.getlimitget();

        //重置为未勾选
        _that.isCheckXieyi = false;
      }

      _that.pidInfo = _that.$common.getInfoByPid(_that.peerid);
      // 测速网设备不支持小宝驿站
      // 134为测速网设备
      if (_that.pidInfo.cid == 134) {
        // 弹窗逻辑
        _that.isShowMessage = true;
        _that.isUnsupportSpeed = true;
      } else {
        _that.isShowMessage = false;
        _that.isUnsupportSpeed = false;
      }

      _that.$store.state.cur_pid = newval;
      // console.log(
      // 	"_that.$store.state.cur_pid",
      // 	_that.$store.state.cur_pid,
      // 	newval
      // );
    },

    pointsArray: function (newval) {},
  },
  activated() {
    this.init();
  },
  mounted() {
    let _that = this;

    _that.readguideget([
      function (err, data) {
        if (data && !data.rtn) {
          //rtn等于0时，后台不返回此字段
          // for test
          // data.read = 0;

          if (data.read == 0) {
            _that.guideStepFlag = 2;
          }
        }
      },
    ]);

    _that.myUserGrowthInfo();
  },
};
</script>
<style lang="less" scoped>
.speed-share {
  position: relative;
  padding-top: 1px;
  height: 550px;
  box-sizing: border-box;

  .loading-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 9;
    background-color: rgba(255, 255, 255, 0.3);
    img {
      margin-top: 280px;
    }
  }

  .device-tabs {
    padding-right: 10px;
    padding-left: 10px;
    background-image: url("../assets/home/node/tabs_shadow_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 7px;
    background-position: bottom;

    .list-wrap {
      position: relative;
      height: 84px;
      .list-wrap-hr {
        width: 100%;
        height: 1px;
        position: absolute;
        top: 5px;
        left: 0;
        background-color: #f5f5f5;
      }
      .arrow {
        display: inline-block;
        position: absolute;
        top: 6px;
        z-index: 3;
        width: 31px;
        height: 71px;
        background-color: rgba(251, 253, 255, 0.86);
        background-size: 10px 17px;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
      }
      .arrow-left {
        background-image: url("../assets/home/node/arrow_left.svg");
        left: 0;
      }
      .arrow-right {
        background-image: url("../assets/home/node/arrow_right.svg");
        right: 94px;
        right: 188px;
      }
      .device-btn-group {
        position: absolute;
        right: 0;
        z-index: 3;
        top: 6px;

        .device-btn {
          height: 71px;
          width: 94px;
          background-color: #e8f5fe;
          box-sizing: border-box;
          text-align: center;
          display: inline-block;
          vertical-align: top;

          .device-btn-text {
            margin-top: 4px;
            color: #1f5de3;
            font-size: 12px;
          }
          .add-device-icon,
          .set-device-icon,
          .about-icon {
            margin-top: 15px;
            width: 20px;
            height: 20px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
            display: inline-block;
          }
          .add-device-icon {
            background-image: url("../assets/home/node/device_add.png");
          }
          .set-device-icon {
            background-image: url("../assets/home/node/device_setting.png");
          }
          .about-icon {
            background-image: url("../assets/home/node/about_icon.png");
          }
        }
        .device-btn:nth-child(2) {
          padding-left: 1px;
          background-image: url("../assets/home/node/tab_line.png");
          background-size: 1px 41px;
          background-repeat: no-repeat;
          background-position: left center;
        }
        .device-btn:hover {
          cursor: pointer;
          opacity: 0.9;
        }
      }

      .list {
        padding-top: 6px;
        // padding-right: 125px;
        // padding-right: 220px;
        width: 675px;
        width: 940px;
        padding-left: 31px;
        white-space: nowrap;
        overflow-x: hidden;
        overflow-y: hidden;
        height: 78px;
        background-image: url("../assets/home/node/tabs_shadow.png");
        background-repeat: no-repeat;
        background-size: 100% 7px;
        background-position: bottom;
        -ms-overflow-style: none;
        scrollbar-width: none;

        .item {
          position: relative;
          width: 189px;
          height: 71px;
          display: inline-block;
          background-color: #ebebeb;
          border-top-left-radius: 2px;
          box-sizing: border-box;
          cursor: pointer;

          .device-bind-wrap {
            width: 100%;
            height: 100%;
            .device-status-wrap {
              display: inline-block;
              vertical-align: top;
              margin-top: 10px;
              .device-icon {
                position: relative;
                z-index: 2;
                width: 48px;
                height: 48px;
                margin-left: 10px;
                background-image: url("../assets/home/node/device.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;

                .device-status {
                  position: absolute;
                  bottom: -5px;
                  left: 50%;
                  transform: translate(-50%, 0);
                  width: 31px;
                  height: 14px;
                  line-height: 14px;
                  text-align: center;
                  background-color: #1f5de3;
                  border-radius: 41px;

                  div {
                    font-size: 12px;
                    color: #f0f0f0;
                    transform: scale(0.75);
                  }
                }
                .device-status-off {
                  background-color: #999999;
                }
              }
              .device-icon-off {
                background-image: url("../assets/home/node/service_device_icon_off.png");
              }
            }

            .device-name-wrap {
              position: relative;
              z-index: 2;
              margin-left: 8px;
              display: inline-block;
              vertical-align: top;
              margin-top: 18px;
              .device-name {
                color: #1c1f28;
                font-size: 14px;
                width: 120px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: bolder;
              }
              .device-ip {
                color: #999999;
                font-size: 12px;
                transform: scale(0.8);
                transform-origin: left center;
              }
            }
          }
        }

        .item:nth-child(n + 2) {
          padding-left: 1px;
          background-image: url("../assets/home/node/tab_line.png");
          background-size: 1px 52px;
          background-repeat: no-repeat;
          background-position: left center;
        }

        .item:hover {
          background-color: #f0f3f8;
        }

        .activeWrap {
          position: relative;

          .activeLeftBg {
            position: absolute;
            top: -18px;
            z-index: 1;
            left: -12px;
            width: 225px;
            height: 105px;
            // background-image: url("../assets/home/node/tab_bg1.png");
            // background-image: url("../assets/speedShare/tab_bg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
            overflow: hidden;
            .bgBlack {
              margin-left: 13px;
              box-shadow: 2px 0px 6px 0px rgba(193, 193, 193, 0.9);
            }
          }
          .activeRightBg {
            position: absolute;
            top: -18px;
            z-index: 1;
            left: -23px;
            width: 224px;
            height: 105px;
            // background-image: url("../assets/home/node/tab_bg2.png");
            // background-image: url("../assets/speedShare/tab_bg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
            overflow: hidden;
            .bgBlack {
              margin-left: 23px;
            }
          }
          .activeMiddleBg {
            position: absolute;
            top: -18px;
            z-index: 1;
            left: -24px;
            width: 237px;
            height: 105px;
            // background-image: url("../assets/home/node/tab_bg3.png");
            // background-image: url("../assets/speedShare/tab_bg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
            overflow: hidden;
            .bgBlack {
              margin-left: 24px;
            }
          }
          .bgBlack {
            margin-top: 15px;
            width: 190px;
            height: 74px;
            background-color: #ffffff;
            box-shadow: 0px 0px 8px 0px rgba(193, 193, 193, 0.9);
            border-top-left-radius: 3px;
            border-top-right-radius: 3px;
          }
        }
      }
      .list::-webkit-scrollbar {
        display: none;
      }
      .nopadding {
        padding-left: 0;
      }
    }
  }

  .head {
    display: flex;
    align-items: center;
    width: 915px;
    height: 48px;
    background-color: #e8f5fe;
    font-size: 14px;
    color: #294075;

    img {
      margin-left: 31px;
      margin-right: 3px;
      margin-top: -1px;
      width: 16px;
      height: 13px;
      cursor: pointer;
    }
    div {
      cursor: pointer;
    }
  }

  .offline {
    width: 100%;
    height: 330px;
    overflow: hidden;
    .offline_title {
      color: rgba(26, 26, 26, 1);
      font-size: 14px;
      font-weight: bolder;
      margin-top: 50px;
      text-align: center;
    }
    .offline_icon {
      width: 305px;
      height: 170px;
      margin: 0 auto;
      margin-top: 35px;
      background-image: url(../assets/home/node/offline_icon.png);
      background-size: 100% 100%;
    }
  }

  .tip-text {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    padding-left: 31px;
    padding-right: 31px;
    font-size: 12px;
    color: #f5f5f5;
    background-color: rgba(102, 102, 102, 0.8);
    height: 49px;
    margin-left: -25px;
    margin-left: -50px;
    line-height: 49px;
    border-radius: 3px;
  }

  .content-wrap.content-normal-wrap {
    background-color: transparent;
    background-image: url(../assets/speedShare/normal_mode_bg.png);
    background-size: 100% 100%;

    .go_mall_wrap {
      display: none;
    }
    .coin-wrap {
      display: none;
    }
    .normal-desc-wrap {
      display: block;
      width: 545px;
      height: 415px;
      background-image: url(../assets/speedShare/normal_desc_bg.png);
      background-repeat: no-repeat;
      background-size: 420px 262px;
      background-position: center 64px;
      position: absolute;
      bottom: 0;
      left: 0;
      overflow: hidden;
      .desc-text {
        margin: 0 auto;
        margin-top: 46px;
        width: 215px;
        height: 24px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        background-image: url("../assets/speedShare/normal_desc_text.svg");
      }
      .desc-btn {
        width: 150px;
        height: 43px;
        line-height: 43px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        background-image: url("../assets/speedShare/desc_btn.png");
        border-radius: 23px;
        margin: 0 auto;
        margin-top: 235px;
        color: #ffffff;
        font-size: 17px;
        font-weight: bolder;
        text-align: center;
      }
      .desc-btn:hover {
        cursor: pointer;
        opacity: 0.9;
      }
      .desc-btn-tips {
        color: #9aa8c6;
        font-size: 12px;
        text-align: center;
        margin-top: 4px;
        transform-origin: center;
      }
    }
  }
  .content-wrap {
    position: relative;
    /*padding-right: 10px;*/
    margin: 0 auto;
    margin-left: 10px;
    margin-right: 10px;
    height: 500px;
    box-sizing: border-box;
    border-top: none;
    background-color: #1956c6;
    /*background-image: url("../assets/speedShare/speed_share.png");*/
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
    border-radius: 5px;

    .normal-desc-wrap {
      display: none;
    }

    .go_mall_wrap {
      position: absolute;
      top: 40px;
      left: 0px;
      height: 28px;
      width: 90px;
      background-image: url(../assets/speedShare/go_mall_bg.svg);
      background-size: 100% 100%;
      z-index: 9;
      text-align: center;
      overflow: hidden;
      .go_mall_icon {
        height: 17px;
        width: 17px;
        display: inline-block;
        margin-top: 4px;
        margin-right: 4px;
        vertical-align: top;
        background-image: url(../assets/speedShare/go_mall_icon.svg);
        background-size: 100% 100%;
      }
      .go_mall_text {
        display: inline-block;
        vertical-align: top;
        color: #ed692f;
        font-size: 12px;
        height: 28px;
        line-height: 28px;
      }
    }
    .go_mall_wrap:hover {
      cursor: pointer;
      opacity: 0.9;
    }

    .text-wrap {
      position: absolute;
      top: 45px;
      font-size: 12px;
      color: #eedbab;
      z-index: 1;
      width: 545px;
      text-align: center;

      .text-icon {
        margin: 0 auto;
        margin-bottom: 3px;
        width: 156px;
        height: 24px;
        background-image: url("../assets/speedShare/a10.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .text-title {
        margin: 0 auto;
        margin-bottom: 3px;
        height: 24px;
        font-size: 18px;
        font-weight: bolder;
        color: #f8d681;
      }
    }

    .list-wrap {
      margin-left: 10px;
      margin-top: 10px;
      position: relative;
      padding-top: 5px;
      padding-left: 8px;
      padding-right: 8px;
      background-color: rgba(255, 255, 255, 0.94);
      height: 71px;
      width: 475px;
      box-sizing: border-box;
      border-radius: 3px;

      .arrow {
        display: inline-block;
        position: absolute;
        top: 5px;
        z-index: 3;
        width: 20px;
        height: 61px;
        background-color: rgba(251, 253, 255, 0.86);
        background-size: 10px 17px;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
      }
      .arrow-left {
        background-image: url("../assets/home/node/arrow_left.png");
        left: 5px;
        box-shadow: 0px 0px 6px 0px rgba(193, 193, 193, 0.3);
      }
      .arrow-right {
        background-image: url("../assets/home/node/arrow_right.png");
        right: 5px;
        box-shadow: 0px 0px 6px 0px rgba(193, 193, 193, 0.3);
      }

      .list {
        padding-right: 17px;
        padding-left: 17px;
        white-space: nowrap;
        overflow-x: hidden;
        overflow-y: hidden;
        height: 61px;
        -ms-overflow-style: none;
        scrollbar-width: none;

        .item {
          position: relative;
          width: 189px;
          height: 61px;
          display: inline-block;
          background-color: #ebebeb;
          border-top-left-radius: 2px;
          box-sizing: border-box;
          cursor: pointer;

          .device-bind-wrap {
            width: 100%;
            height: 100%;
            .device-status-wrap {
              width: 48px;
              height: 48px;
              display: inline-block;
              vertical-align: top;
              margin-left: 10px;
              margin-top: 8px;
              .device-icon {
                position: relative;
                z-index: 2;
                width: 48px;
                height: 48px;

                background-image: url("../assets/home/node/device.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;

                .device-status {
                  position: absolute;
                  bottom: -5px;
                  left: 50%;
                  transform: translate(-50%, 0);
                  width: 31px;
                  height: 14px;
                  line-height: 14px;
                  text-align: center;
                  background-color: #1f5de3;
                  border-radius: 41px;

                  div {
                    font-size: 12px;
                    color: #f0f0f0;
                    transform: scale(0.75);
                  }
                }
                .device-status-off {
                  background-color: #999999;
                }
              }
              .device-icon-off {
                background-image: url("../assets/home/node/service_device_icon_off.png");
              }
            }

            .device-name-wrap {
              position: relative;
              z-index: 2;
              margin-left: 10px;
              margin-top: 12px;
              width: 120px;
              display: inline-block;
              vertical-align: top;
              .device-name {
                color: #1c1f28;
                font-size: 14px;
                width: 120px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .device-ip {
                color: #999999;
                font-size: 12px;
                transform: scale(0.8);
                margin-left: -13px;
                padding-left: 12px;
                background-image: url("../assets/speed/speed_device_on.svg");
                background-size: 9px 9px;
                background-repeat: no-repeat;
                background-position: left center;
              }
              .device-ip1 {
                background-image: url("../assets/speed/speed_device_off.svg");
              }
            }
          }
        }

        .item:nth-child(n + 2) {
          padding-left: 1px;
          background-image: url("../assets/home/node/tab_line.png");
          background-size: 1px 52px;
          background-repeat: no-repeat;
          background-position: left center;
        }

        .tabsItemActive {
          background-color: #e8f5fe;
          border: 1px solid rgba(31, 93, 227, 0.12);
          background-image: none !important;
          padding-left: 0px !important;
        }
        .tabsItemActive + .item {
          background-image: none !important;
          padding-left: 0px !important;
        }
      }
      .list::-webkit-scrollbar {
        display: none;
      }
      .nopadding {
        padding-left: 0;
      }
    }
    .list-wrap-extra {
      position: absolute;
      z-index: 10;
    }
    .new-wrap {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 1;
      width: 385px;
      height: 490px;

      .blank-panel {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 385px;
        height: 20px;
        background-color: #fefefe;
        z-index: 9;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
      }

      .speed-info-wrap {
        position: relative;
        padding-top: 20px;
        padding-bottom: 20px;
        background-color: #fefefe;
        width: 385px;
        height: 500px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        box-shadow: 0px 0px 10px 0px rgba(193, 193, 193, 0.3);
        overflow-y: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;
        box-sizing: border-box;

        .mode_title {
          font-size: 16px;
          font-weight: bolder;
          color: #1a1a1a;
          height: 40px;
          line-height: 40px;
          position: relative;
          width: 300px;
          margin: 0 auto;
          margin-top: 0px;
          border-bottom: 1px solid #e6e6e6;
          .change_mode_btn {
            position: absolute;
            right: 0;
            top: 10px;
            height: 30px;
            line-height: 30px;
            font-size: 12px;
            color: #244ea7;
            background-color: #ebeef5;
            border-radius: 15px;
            padding: 0 10px;
            font-weight: normal;
          }
          .change_mode_btn:hover {
            opacity: 0.8;
            cursor: pointer;
          }
          .change_mode_btn.change_mode_btn_red {
            background-color: #ffeacf;
            color: #e67532;
          }
        }
        .mode_title.mode_title_points {
          margin-top: 10px;
        }

        .mode_type {
          margin: 0 auto;
          margin-top: 10px;
          width: 300px;
          height: 70px;
          border: 1px solid #2460e0;
          border-radius: 5px;
          text-align: center;
          background-color: #dbe5fb;
          background-image: url("../assets/speedShare/mode_type_select.svg");
          background-position: right bottom;
          background-repeat: no-repeat;
          background-size: 27px 27px;
          box-sizing: border-box;
          .mode_type_icon {
            display: inline-block;
            vertical-align: top;
            width: 40px;
            height: 40px;
            margin-top: 15px;
            background-image: url("../assets/speedShare/mode_speed_icon.svg");
            background-size: 100% 100%;
          }
          .mode_type_icon.mode_type_icon_normal {
            background-image: url("../assets/speedShare/mode_normal_icon.svg");
          }
          .mode_type_text {
            display: inline-block;
            vertical-align: top;
            font-size: 15px;
            color: #2460e0;
            height: 20px;
            margin-top: 25px;
            font-weight: bolder;
            margin-left: 10px;
          }
        }

        .mode_types {
          text-align: center;
          .mode_type {
            margin-right: 5px;
            margin-left: 5px;
            display: inline-block;
            vertical-align: top;
            width: 144px;
            height: 63px;
            border: 1px solid #2460e0;
            border-radius: 5px;
            text-align: center;
            background-color: #dbe5fb;
            background-image: url("../assets/speedShare/mode_type_select.svg");
            background-position: right bottom;
            background-repeat: no-repeat;
            background-size: 27px 27px;
            box-sizing: border-box;
            .mode_type_icon {
              display: inline-block;
              vertical-align: top;
              width: 36px;
              height: 36px;
              margin-top: 13px;
              background-image: url("../assets/speedShare/mode_speed_icon.svg");
              background-size: 100% 100%;
            }
            .mode_type_icon.mode_type_icon_normal {
              background-image: url("../assets/speedShare/mode_normal_icon.svg");
            }
            .mode_type_text {
              display: inline-block;
              vertical-align: top;
              font-size: 15px;
              color: #2460e0;
              height: 20px;
              margin-top: 20px;
              font-weight: bolder;
              margin-left: 10px;
            }
          }
          .mode_type_normal:hover {
            cursor: pointer;
          }
          .mode_type_speed {
            background-color: rgba(237, 243, 255, 1);
            border: 1px solid rgba(36, 96, 224, 0.2);
            background-image: none;
            .mode_type_icon {
              background-image: url("../assets/speedShare/mode_speed_icon2.png");
            }

            .mode_type_text {
              color: rgba(36, 96, 224, 1);
            }
          }
          .mode_type_speed:hover,
          .mode_type_speed_hover {
            cursor: pointer;
            background-color: rgba(255, 234, 207, 1);
            border: 1px solid rgba(233, 131, 70, 0.5);
            .mode_type_icon {
              background-image: url("../assets/speedShare/mode_speed_icon_hover.png");
            }
            .mode_type_text {
              color: rgba(236, 146, 89, 1);
            }

            .mode_desc.mode_desc_speed {
              display: block;
            }
          }
        }

        .mode_desc {
          width: 300px;
          height: 188px;
          margin: 0 auto;
          margin-top: 10px;
          margin-bottom: 20px;
          background-image: url("../assets/speedShare/mode_desc_bg.jpg");
          background-position: top center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          border-radius: 6px;
          overflow: hidden;
          .mode_desc_title {
            color: #244ea7;
            font-size: 14px;
            text-align: center;
            height: 20px;
            line-height: 20px;
            margin-top: 20px;
            font-weight: bolder;
            background-image: url("../assets/speedShare/mode_desc_title_bg.svg");
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 188px auto;
          }
          .mode_desc_item_wrap {
            margin-top: 25px;
            text-align: center;
            .mode_desc_item {
              display: inline-block;
              vertical-align: top;
              width: 100px;
              height: 70px;
              box-sizing: border-box;
              background-position: top center;
              background-repeat: no-repeat;
              background-size: 60px 60px;
              .mode_desc_item_text {
                text-align: center;
                font-size: 12px;
                color: rgba(236, 146, 89, 1);
                margin-top: 70px;
                height: 20px;
                line-height: 20px;
                font {
                  display: inline-block;
                  vertical-align: text-bottom;
                }
                .num {
                  font-weight: bolder;
                  font-size: 16px;
                  margin-right: 2px;
                }
              }
            }
            .mode_desc_item_01 {
              background-image: url("../assets/speedShare/speed_desc_icon.png");
            }
          }

          .mode_desc_btn {
            // display: none;
            width: 172px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background-color: rgba(255, 180, 70, 1);
            color: #fefefe;
            font-size: 14px;
            font-weight: bolder;
            margin: 0 auto;
            margin-top: 32px;
            border-radius: 20px;
          }
          .mode_desc_btn:hover {
            cursor: pointer;
            opacity: 0.9;
          }
        }

        .mode_desc.mode_desc_speed {
          display: none;
          background-image: url(../assets/speedShare/mode_speed_bg2.png);
          background-size: 100% 100%;
          width: 300px;
          height: 244px;
          position: absolute;
          left: 42px;
          bottom: -4px;
          z-index: 2;
          .mode_desc_title {
            margin-top: 30px;
            color: rgba(233, 149, 22, 1);
            background-image: url("../assets/speedShare/mode_desc_title_bg2.png");
          }

          .mode_desc_item_01 {
            background-image: url("../assets/speedShare/speed_desc_icon.png");
            background-size: 58px 58px;
            .mode_desc_item_text {
              color: rgba(236, 146, 89, 1);
            }
          }
        }
        .mode_desc.mode_desc_speed:hover {
          cursor: auto;
        }

        .mode_desc.mode_desc_normal {
          height: 188px;
          background-image: url("../assets/speedShare/mode_desc_bg.png");
          .mode_desc_title {
            color: rgba(104, 113, 125, 1);
          }
          .mode_desc_item_01 {
            background-image: url("../assets/speedShare/normal_desc_icon.png");
          }

          .mode_desc_item {
            .mode_desc_item_text {
              color: rgba(227, 68, 33, 1);
            }
          }
          .mode_desc_btn {
            display: block;
          }
        }
        .go_mall_btn2 {
          margin: 0 auto;
          margin-top: 50px;
          width: 150px;
          height: 41px;
          line-height: 41px;
          border-radius: 58px;
          background-image: linear-gradient(to bottom, #ed962f, #e95d1f);
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          color: #fefefe;
          cursor: pointer;
          box-shadow: 0 2px 8px 0 rgba(143, 63, 28, 0.2);
        }

        .unsupport_wrap {
          .unsupport_icon {
            width: 220px;
            height: 210px;
            margin: 0 auto;
            background-image: url("../assets/speedShare/unsupport_icon.svg");
            background-size: 100% 100%;
          }
          .unsupport_desc {
            font-size: 12px;
            color: #e23e20;
            font-size: 12px;
            text-align: center;
            margin-top: 15px;
          }
          .unsupport_retest_btn {
            background-color: #1f5de3;
            width: 113px;
            height: 36px;
            margin: 0 auto;
            margin-top: 40px;
            margin-bottom: 10px;
            line-height: 36px;
            border-radius: 18px;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
          }
        }

        .points_wrap {
          width: 340px;
          height: 65px;
          background-color: rgba(245, 249, 255, 1);
          border-radius: 28px;
          margin: 0 auto;
          margin-top: 20px;
          text-align: center;
          background-color: #f5f9ff;
          border: 1px solid #e6edf9;
          box-shadow: 0px 3px 6px rgba(187, 193, 203, 0.19);
          border-radius: 8px;
          .points_item_line {
            display: inline-block;
            vertical-align: top;
            width: 1px;
            height: 34px;
            background-color: RGBA(209, 218, 236, 1);
            margin-top: 11px;
          }
          .points_item {
            display: inline-block;
            vertical-align: top;
            width: 49%;
            text-align: left;

            .points_icon {
              display: inline-block;
              vertical-align: top;
              width: 20px;
              height: 20px;
            }
            .points_info {
              display: inline-block;
              vertical-align: top;
              // margin-left: 4px;
              margin-top: 10px;
              text-align: center;
              width: 100%;
              .points_title {
                font-size: 12px;
                color: rgba(114, 124, 147, 1);
                line-height: 16px;
              }
              .points_value {
                line-height: 20px;
                margin-top: 5px;
                color: rgba(114, 124, 147, 1);
                font {
                  font-size: 20px;
                  margin-right: 4px;
                }
              }
            }
          }
          .points_item.points_item_all {
            .points_icon {
              background-image: url(../assets/points/all_points.png);
              background-size: 100% 100%;
            }
            .points_value {
              font {
                color: rgba(22, 76, 194, 1);
              }
            }
          }
          .points_item.points_item_yesterday {
            .points_icon {
              background-image: url(../assets/points/yesterday_points.png);
              background-size: 100% 100%;
            }
            .points_value {
              font {
                color: rgba(241, 155, 25, 1);
              }
            }
          }
        }

        .points-btns {
          text-align: center;
          margin-top: 20px;
        }

        .rules {
          font-size: 14px;
          color: #244ea7;
          cursor: pointer;
          border-radius: 16px;
          text-align: center;
          width: 88px;
          height: 32px;
          line-height: 32px;
          background-color: rgba(36, 78, 167, 0.1);
          display: inline-block;
          vertical-align: top;
          margin: 0 12px;
        }

        .info-wrap {
          text-align: center;
          .info-line {
            width: 1px;
            height: 16px;
            background-color: #e6e6e6;
            display: inline-block;
            vertical-align: top;
            margin-top: 30px;
          }
          .info-status {
            width: 110px;
            display: inline-block;
            vertical-align: top;
            margin-top: 18px;
            .status-title {
              font-weight: 400;
              font-size: 12px;
              line-height: 16px;
              color: #6a6a6a;
            }
            .status-value {
              font-weight: 400;
              font-size: 16px;
              line-height: 21px;

              margin-top: 4px;
            }
            .status-value1 {
              color: #ff764a;
            }
            .status-value2 {
              color: #4176ff;
            }
            .status-value3 {
              color: #31a906;
            }
          }
          .device-bind-wrap {
            display: inline-block;
            vertical-align: top;
            width: 190px;
            height: 100%;
            .device-status-wrap {
              display: inline-block;
              vertical-align: top;
              margin-top: 10px;
              .device-icon {
                position: relative;
                z-index: 2;
                width: 48px;
                height: 48px;
                margin-left: 10px;
                background-image: url("../assets/home/node/device.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;

                .device-status {
                  position: absolute;
                  bottom: -5px;
                  left: 50%;
                  transform: translate(-50%, 0);
                  width: 31px;
                  height: 14px;
                  line-height: 14px;
                  text-align: center;
                  background-color: #1f5de3;
                  border-radius: 41px;

                  div {
                    font-size: 12px;
                    color: #f0f0f0;
                    transform: scale(0.75);
                  }
                }
                .device-status-off {
                  background-color: #999999;
                }
              }
              .device-icon-off {
                background-image: url("../assets/home/node/service_device_icon_off.png");
              }
            }

            .device-name-wrap {
              position: relative;
              z-index: 2;
              margin-left: 8px;
              display: inline-block;
              vertical-align: top;
              margin-top: 18px;
              .device-name {
                color: #1c1f28;
                font-size: 14px;
                width: 120px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: bolder;
                text-align: left;
              }
              .device-ip {
                color: #999999;
                font-size: 12px;
                transform: scale(0.8);
                transform-origin: left center;
                text-align: left;
              }
            }
          }
        }

        .info-title {
          margin-top: 22px;
          margin-left: 41px;
          color: #666666;
          font-size: 14px;
          height: 12px;
          font-weight: bolder;
          div {
            display: inline-block;
            vertical-align: top;
          }

          div:nth-child(1) {
            margin-right: 5px;
            width: 3px;
            height: 10px;
            border-radius: 20px;
            background-color: #1f5de3;
            margin-top: 4px;
          }
          div:nth-child(2) {
            margin-top: 0px;
          }
        }

        .chart-wrap {
          position: relative;

          .date-text1,
          .date-text2 {
            position: absolute;
            bottom: 0;
            color: rgba(203, 203, 203, 1);
            font-size: 12px;
          }
          .date-text1 {
            left: 77px;
          }
          .date-text2 {
            right: 47px;
          }
        }

        .vip-text {
          margin: 0 auto;
          margin-top: 20px;
          width: 180px;
          text-align: center;
          white-space: nowrap;
          height: 20px;
          line-height: 20px;
          border-radius: 20px;
          background-color: rgba(226, 62, 32, 0.08);
          font-size: 12px;
          color: #e23e20;
          cursor: pointer;
        }
        .total-points {
          margin-top: 15px;
          text-align: center;
          color: #666666;
          font-size: 27px;
          font-weight: bold;

          span {
            color: #999999;
            font-size: 12px;
            font-weight: normal;
            margin-left: 3px;
          }
        }
        .exchange-btn {
          /*margin: 0 auto;*/
          margin-left: 150px;
          margin-top: 4px;
          text-align: center;
          width: 78px;
          height: 27px;
          line-height: 27px;
          border-radius: 20px;
          background-color: #fcc11a;
          background-image: linear-gradient(to right, #fcc11a, #faaf1b);
          color: #f5f5f5;
          font-weight: bold;
          font-size: 12px;
        }
        .exchange-btn:hover {
          cursor: pointer;
          opacity: 0.9;
        }
        .path-wrap-wrap {
          width: 293px;
          margin: 0 auto;
          margin-bottom: 8px;
          margin-top: 20px;
        }
        .path-wrap {
          position: relative;
          text-align: left;
          width: 220px;
          height: 27px;
          line-height: 27px;
          background-color: #ffffff;
          border-radius: 204px;
          display: inline-block;
          overflow: hidden;
          vertical-align: top;
          text-overflow: ellipsis;
          white-space: nowrap;

          .path-text {
            padding-left: 14px;
            font-size: 12px;
            color: #666666;
            overflow: hidden;
            vertical-align: top;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .path-tips {
          color: #999999;
          font-size: 12px;
          margin-left: 55px;
        }

        .show-desc-btn {
          text-align: center;
          margin-top: 5px;
          .show-desc-icon {
            display: inline-block;
            vertical-align: top;
            height: 17px;
            width: 17px;
            background-image: url(../assets/speedShare/show-desc-icon.svg);
            background-size: 100% 100%;
            margin-right: 7px;
          }
          .show-desc-text {
            display: inline-block;
            vertical-align: top;
            color: #1f5de3;
            font-size: 12px;
            height: 18px;
            line-height: 18px;
          }
        }

        .show-desc-btn:hover {
          cursor: pointer;
          opacity: 0.8;
        }

        .path-btn {
          background-color: #215fe4;
          width: 60px;
          height: 26px;
          line-height: 26px;
          color: #ffffff;
          text-align: center;
          border-radius: 15px;
          display: inline-block;
          margin-left: 10px;
          font-size: 13px;
          vertical-align: top;
        }
        .path-btn:hover {
          cursor: pointer;
          opacity: 0.9;
        }

        .cache-wrap {
          margin: 0 auto;
          position: relative;
          width: 285px;
          box-sizing: border-box;
          padding-top: 14px;
          margin-top: 20px;

          .cache-btn {
            position: absolute;
            top: 7px;
            width: 20px;
            height: 20px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
          }
          .cache-btn-unactive {
            left: 0;
            background-image: url("../assets/speed/speed_info7.png");
          }
          .cache-btn-active-middle {
            left: 132px;
            background-image: url("../assets/speed/speed_info2.png");
          }
          .cache-btn-active-right {
            right: 0;
            background-image: url("../assets/speed/speed_info2.png");
          }

          .cache-click-wrap {
            position: absolute;
            z-index: 9;
            left: 0;
            top: 0;
            width: 285px;
            height: 48px;
            cursor: pointer;
            div {
              width: 33%;
              height: 100%;
              display: inline-block;
              vertical-align: top;
              z-index: 9;
            }
          }

          .cache-line {
            margin: 0 auto;
            width: 265px;
            height: 4px;
            background-image: url("../assets/speed/cache_line.svg");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
            box-sizing: border-box;
          }
          .cache-line-half {
            background-image: url("../assets/speed/cache_line_half.svg");
          }
          .cache-line-full {
            background-image: url("../assets/speed/cache_line_full.svg");
          }
          .cache-text {
            margin: 0 auto;
            margin-top: 14px;
            width: 285px;
            justify-content: space-between;
            div {
              color: #999999;
              font-size: 12px;
              display: inline-block;
              vertical-align: top;
              width: 33%;
              cursor: pointer;
            }
            .cache-text-weight {
              font-weight: bold;
              color: #1f5de3;
            }
          }
        }
        .warm-text {
          margin-top: 5px;
          margin-left: 49px;
          margin-bottom: 40px;
          font-size: 12px;
          color: #999999;
        }

        .save-btn {
          margin: 0 auto;
          margin-top: 40px;
          width: 143px;
          height: 36px;
          line-height: 36px;
          background-color: #215fe4;
          border-radius: 20px;
          color: #f5f5f5;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          box-shadow: 0px 0px 5px 1px rgba(193, 193, 193, 0.5);
        }
        .save-btn:hover {
          opacity: 0.9;
        }
        .setting-btns {
          text-align: center;
          margin-top: 10px;
          margin-bottom: 30px;
        }
        .setting-btn {
          text-align: center;

          text-align: center;
          font-size: 14px;
          color: #999999;
          cursor: pointer;
          display: inline-block;
          margin: 0 5px;

          div {
            border-bottom: 1px solid #999999;
            display: inline-block;
          }
        }
        .info-content {
          margin-bottom: 30px;
          margin-top: 15px;

          .btn1,
          .btn2 {
            text-align: center;
            display: inline-block;
            width: 75px;
            height: 29px;
            line-height: 29px;
            border-radius: 31px;
            background-color: #e9e9e9;
            color: #666666;
            font-size: 12px;
            cursor: pointer;
          }
          .btn1 {
            margin-left: 45px;
          }
          .btn2 {
            margin-left: 17px;
          }
          .active {
            border: 1px solid #2460e0;
            background-color: #dbe5fb;
            color: #2460e0;
          }
        }
      }
      .speed-info-wrap::-webkit-scrollbar {
        display: none;
      }
    }
    .new-wrap::after {
      position: absolute;
      content: "";
      bottom: 0;
      left: 0px;
      width: 385px;
      height: 20px;
      background-color: #fefefe;
      z-index: 9;
    }
    .coin-wrap {
      width: 545px;
      height: 415px;
      background-image: url(../assets/speedShare/coin_bg.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      position: absolute;
      bottom: 0;
      left: 0;

      .coin_enter {
        position: absolute;
        left: 50%;
        margin-left: -45px;
        bottom: 170px;
        width: 90px;
        height: 12px;
        background-image: url(../assets/speedShare/coin_enter.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
      }
      .coin_bottom {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: 0px;
        width: 250px;
        height: 95px;
        background-image: url(../assets/speedShare/coin_bottom.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
      }
      .coin_bottom_coin {
        position: absolute;
        left: 50%;
        margin-left: 25px;
        bottom: 15px;
        width: 46px;
        height: 28px;
        background-image: url(../assets/speedShare/coin_bottom_coin.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
      }
      .coin_bottom_ticket {
        position: absolute;
        left: 50%;
        margin-left: -115px;
        bottom: 15px;
        width: 46px;
        height: 36px;
        background-image: url(../assets/speedShare/coin_bottom_ticket.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
      }
      .coin_border {
        position: absolute;
        left: 50%;
        margin-left: -114px;
        bottom: 50px;
        width: 230px;
        height: 170px;
        background-image: url(../assets/speedShare/coin_border.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        transform-origin: bottom;
        opacity: 0.5;
      }
      .coin_border_normal {
        animation: coin_border_normal 5s infinite linear;
      }
      @keyframes coin_border_normal {
        0% {
          opacity: 0.5;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0.5;
        }
      }
      .coin_border_animation {
        animation: coin_border 1s 1 linear;
      }
      @keyframes coin_border {
        0% {
          transform: none;
          opacity: 0.5;
        }
        50% {
          transform: scaleY(1.1);
          opacity: 1;
        }
        100% {
          transform: none;
          opacity: 0.5;
        }
      }

      .coin_bottom_left {
        position: absolute;
        left: 50%;
        margin-left: -100px;
        bottom: 60px;
        width: 200px;
        height: 18px;
        background-image: url(../assets/speedShare/coin_bottom_left.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
      }
      .coin_bottom_left_once {
        animation: coin_bottom_left 1s 1 linear;
      }

      @keyframes coin_bottom_left {
        0% {
          margin-left: -100px;
        }
        50% {
          margin-left: -150px;
        }
        100% {
          margin-left: -100px;
        }
      }

      .coin_bottom_right {
        position: absolute;
        left: 50%;
        margin-left: -100px;
        bottom: 60px;
        width: 200px;
        height: 18px;
        background-image: url(../assets/speedShare/coin_bottom_right.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
      }
      .coin_bottom_right_once {
        animation: coin_bottom_right 1s 1 linear;
      }

      @keyframes coin_bottom_right {
        0% {
          margin-left: -100px;
        }
        50% {
          margin-left: -50px;
        }
        100% {
          margin-left: -100px;
        }
      }
      .coin_bottom_coins {
        position: absolute;
        left: 50%;
        margin-left: -98px;
        bottom: 60px;
        width: 200px;
        height: 30px;
        background-image: url(../assets/speedShare/coin_bottom_coins.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
      }
      .coin_contain_coin {
        position: absolute;
        left: 50%;
        margin-left: 0px;
        bottom: 64px;
        width: 25px;
        height: 20px;
        background-image: url(../assets/speedShare/coin_contain_coin.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        transform: rotate(37deg);
      }
      .coin_contain_coin_animation {
        animation: coin_contain_coin 1s 1 ease-in forwards;
      }
      @keyframes coin_contain_coin {
        0% {
          bottom: 64px;
          transform: rotate(37deg);
        }

        30% {
          bottom: 124px;
          margin-left: 55px;
          transform: rotate(0deg);
        }

        40% {
          transform: rotate(90deg);
        }

        50% {
          transform: rotate(180deg);
        }

        60% {
          transform: rotate(270deg);
        }

        70% {
          bottom: 124px;
          transform: rotate(37deg);
        }

        100% {
          bottom: 64px;
          margin-left: 55px;
          transform: rotate(37deg);
        }
      }

      .coin_contain_coin_02 {
        position: absolute;
        left: 50%;
        margin-left: -20px;
        bottom: 60px;
        width: 25px;
        height: 20px;
        background-image: url(../assets/speedShare/coin_contain_coin_02.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        transform: rotate(-45deg);
      }

      .coin_contain_coin_02_animation {
        animation: coin_contain_coin_02 0.6s 1 ease-in forwards;
      }
      @keyframes coin_contain_coin_02 {
        0% {
          bottom: 64px;
          transform: rotate(-45deg);
        }

        30% {
          bottom: 104px;
          margin-left: -55px;
          transform: rotate(-90deg);
        }

        40% {
          transform: rotate(-180deg);
        }

        50% {
          transform: rotate(-270deg);
        }

        60% {
          transform: rotate(-180deg);
        }

        70% {
          bottom: 124px;
          transform: rotate(-45deg);
        }

        100% {
          bottom: 64px;
          margin-left: -55px;
          transform: rotate(-45deg);
        }
      }

      .coin_contain_coin_03 {
        position: absolute;
        left: 50%;
        margin-left: 0px;
        bottom: 64px;
        width: 25px;
        height: 20px;
        background-image: url(../assets/speedShare/coin_contain_coin.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        transform: rotate(37deg);
      }
      .coin_contain_coin_03_animation {
        animation: coin_contain_coin_03 1.4s 1 ease-in forwards;
      }
      @keyframes coin_contain_coin_03 {
        0% {
          bottom: 64px;
          transform: rotate(37deg);
        }

        30% {
          bottom: 144px;
          margin-left: 10px;
          transform: rotate(0deg);
        }

        40% {
          transform: rotate(90deg);
        }

        50% {
          transform: rotate(180deg);
        }

        70% {
          bottom: 144px;
          transform: rotate(37deg);
        }

        100% {
          bottom: 64px;
          margin-left: 10px;
          transform: rotate(37deg);
        }
      }
      .coin_contain_coin_04 {
        position: absolute;
        left: 50%;
        margin-left: -20px;
        bottom: 60px;
        width: 25px;
        height: 20px;
        background-image: url(../assets/speedShare/coin_contain_coin_02.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        transform: rotate(-45deg);
      }
      .coin_contain_coin_04_animation {
        animation: coin_contain_coin_04 1s 1 ease-in forwards;
      }
      @keyframes coin_contain_coin_04 {
        0% {
          bottom: 64px;
          transform: rotate(-45deg);
        }

        30% {
          bottom: 134px;
          margin-left: -40px;
          transform: rotate(-90deg);
        }

        40% {
          transform: rotate(-180deg);
        }

        50% {
          transform: rotate(-270deg);
        }

        70% {
          bottom: 134px;
          transform: rotate(-45deg);
        }

        100% {
          bottom: 64px;
          margin-left: -40px;
          transform: rotate(-45deg);
        }
      }

      .coin_border_left {
        position: absolute;
        left: 50%;
        margin-left: -144px;
        bottom: 55px;
        width: 288px;
        height: 284px;
        background-image: url(../assets/speedShare/coin_border_left.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        transform-origin: bottom;
        opacity: 0.5;
      }
      .coin_border_right_normal {
        animation: coin_border_right_normal 5s infinite linear;
      }
      @keyframes coin_border_right_normal {
        0% {
          transform: none;
          opacity: 0.5;
        }
        50% {
          transform: scaleY(1.1);
          opacity: 1;
        }
        100% {
          transform: none;
          opacity: 0.5;
        }
      }

      .coin_border_right_animation {
        animation: coin_border_right 2s infinite linear;
      }
      @keyframes coin_border_right {
        0% {
          transform: none;
          opacity: 0.5;
        }
        50% {
          transform: scaleY(1.1);
          opacity: 1;
        }
        100% {
          transform: none;
          opacity: 0.5;
        }
      }

      .coin_border_left_left {
        position: absolute;
        left: 50%;
        margin-left: -172px;
        bottom: 57px;
        width: 344px;
        height: 220px;
        background-image: url(../assets/speedShare/coin_border_left_left.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        transform-origin: bottom;
        opacity: 0.5;
      }
      .coin_border_right {
        position: absolute;
        left: 50%;
        margin-left: -144px;
        bottom: 55px;
        width: 288px;
        height: 284px;
        background-image: url(../assets/speedShare/coin_border_right.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        transform-origin: bottom;
        opacity: 0.5;
      }
      .coin_border_right_right {
        position: absolute;
        left: 50%;
        margin-left: -172px;
        bottom: 57px;
        width: 344px;
        height: 220px;
        background-image: url(../assets/speedShare/coin_border_right_right.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        transform-origin: bottom;
        opacity: 0.5;
      }
    }
  }

  .normal-wrap {
    background-image: url(../assets/speedShare/normal_bg.jpg);
    background-size: 100% 100%;
    border-radius: 6px;
    .diff-wrap {
      width: 530px;
      margin: 0 auto;
      margin-top: 65px;
      background-image: url(../assets/speedShare/normal_arrow_bg.svg);
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 41px 41px;
      .diff-left-wrap,
      .diff-right-wrap {
        display: inline-block;
        vertical-align: top;
        width: 230px;
        height: 250px;
        text-align: center;
        .diff-top-wrap {
          background-size: 100% 100%;
        }
        .bottom-item {
          color: #432d20;
          font-size: 15px;
        }
      }
      .diff-top-wrap {
        height: 87px;
        overflow: hidden;
      }
      .diff-left-wrap {
        background-color: #f9feff;
        background-image: linear-gradient(to bottom, #f9feff, #e0e7ed);
        border-radius: 5px;
        margin-right: 70px;
        overflow: hidden;
        .diff-top-wrap {
          background-image: url(../assets/speedShare/left_bg.png);
          .diff-title {
            color: #3e454c;
            font-size: 20px;
            font-weight: bolder;
            margin-top: 24px;
          }
          .diff-subtitle {
            color: #ec432c;
            font-weight: bolder;
            font-size: 14px;
            margin-top: 2px;
          }
        }
        .bottom-item {
          text-align: left;
          padding-left: 83px;
          margin-top: 25px;
          background-image: url(../assets/speedShare/select_icon.png);
          background-position: 50px center;
          background-repeat: no-repeat;
          height: 20px;
          line-height: 20px;
        }
      }
      .diff-right-wrap {
        background-color: #f4f7ff;
        background-image: linear-gradient(to bottom, #f4f7ff, #e0ecfe);
        border-radius: 5px;
        overflow: hidden;
        .diff-top-wrap {
          background-image: url(../assets/speedShare/right_bg.png);
          .diff-title {
            color: #2460e0;
            font-size: 20px;
            font-weight: bolder;
            margin-top: 24px;
          }
          .diff-subtitle {
            color: #244ea7;
            font-weight: bolder;
            font-size: 14px;
            margin-top: 2px;
          }
        }
        .bottom-item {
          text-align: left;
          padding-left: 33px;
          margin-top: 22px;
          background-position: 50px center;
          background-repeat: no-repeat;
          .item-text {
            display: inline-block;
            vertical-align: top;
            height: 20px;
            line-height: 20px;
            width: 100px;
          }
          .item-icon {
            display: inline-block;
            vertical-align: top;
            width: 20px;
            height: 20px;
            background-size: 100% 100%;
            margin-right: 5px;
          }
          .item-icon-device {
            background-image: url(../assets/speedShare/device_icon.png);
          }
          .item-icon-speed {
            background-image: url(../assets/speedShare/speed_icon.png);
          }
          .item-icon-coin {
            margin-top: -2px;
            background-image: url(../assets/speedShare/coin_icon.png);
          }
        }
      }
    }
    .speed-btn {
      width: 188px;
      height: 42px;
      line-height: 42px;
      border-radius: 21px;
      font-size: 14px;
      color: #fefefe;
      font-weight: bolder;
      margin: 0 auto;
      margin-top: 35px;
      text-align: center;
      background-color: #1f5de3;
    }
    .speed-btn:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
  .install-wrap {
    margin: 0 auto;
    padding-top: 1px;
    height: 500px;
    width: 940px;
    background-image: url("../assets/speedShare/a4.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    box-sizing: border-box;

    .offline-wrap {
      padding-top: 108px;
      font-size: 17px;
      font-weight: bold;
      color: #1a1a1a;
      line-height: 24px;
      text-align: center;

      .offline-icon {
        margin: 0 auto;
        margin-top: 20px;
        width: 215px;
        height: 169px;
        background-image: url("../assets/speedShare/a11.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
      }
    }
    .install {
      position: relative;
      margin: 0 auto;
      margin-top: 69px;
      padding-top: 38px;
      width: 333px;
      height: 302px;
      border-radius: 7px;
      background-color: #fcfcfc;
      box-sizing: border-box;
      background-image: url("../assets/speedShare/a8.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
      box-shadow: 0 7px 20px 0 rgba(121, 121, 121, 0.15);

      .back-wrap {
        position: absolute;
        top: 15px;
        left: 0;
        padding-left: 31px;
        cursor: pointer;

        .back-text {
          position: relative;
          font-size: 12px;
          color: #999999;
        }
        .back-text::before {
          position: absolute;
          content: "";
          left: -18px;
          width: 17px;
          height: 17px;
          background-image: url("../assets/speedShare/a9.svg");
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100% 100%;
        }
      }

      .text1 {
        margin-top: 10px;
        font-size: 17px;
        font-weight: bold;
        color: #1a1a1a;
        line-height: 24px;
        text-align: center;
      }

      .xcbf-content {
        padding-left: 40px;
        margin-top: 30px;
        .content-item {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC4SURBVHgBlZExDoJAEEX/LthZ0NtwBDyBcBMaEzs8ytKZ2HAT5QZ7A6expzJRJOssLIkFAfYnm8z8vF/sfAGnODlHH7wKAZPymjpb8yuf+lqNnBjgU9yiu9kR06INgoz0hfrALjk+ZuC/ULsPGM55ybGsyCB8Sx4KrJSBOdhAgvVKJTxlA3cPXku+e+0RKGWIr+I6aJkVZAuUpKumg8zmQ4IGxjU9ynbCRmHc5UT/P1OH2CrSqrHeD0CRNhRGfS86AAAAAElFTkSuQmCC);
          background-size: 6px 6px;
          background-repeat: no-repeat;
          background-position: left center;
          margin-bottom: 8px;
          font-weight: 400;
          font-size: 13px;
          line-height: 20px;
          padding-left: 15px;
          color: #666666;
        }
      }
      .icon1 {
        margin: 0 auto;
        margin-top: 30px;
        width: 80px;
        height: 80px;
        background-image: url("../assets/tool/byjs-icon.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
      }
      .xieyi-wrap {
        padding-left: 12px;
        margin-top: 25px;
        text-align: center;
        cursor: pointer;

        .xieyi {
          display: inline-block;
          position: relative;
          text-align: center;
          font-size: 12px;
          color: #999999;
          line-height: 12px;

          .icon2 {
            position: absolute;
            left: -12px;
            top: 2px;
            width: 10px;
            height: 10px;
            background-image: url("../assets/speedShare/a6.svg");
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
          }
          .icon3 {
            background-image: url("../assets/speedShare/a8.svg");
          }

          span {
            color: #999999;
          }
        }
        .red-xieyi {
          color: #ee7155;

          span {
            color: #ee7155;
          }
        }
      }
      .text2 {
        margin-top: 14px;
        padding-left: 30px;
        padding-right: 30px;
        font-size: 12px;
        color: #999999;
        line-height: 20px;
        text-align: center;
      }
      .btns {
        text-align: center;
        margin-top: 15px;
      }
      .open-btn {
        margin: 0 auto;
        margin-left: 20px;
        width: 120px;
        height: 41px;
        line-height: 41px;
        border-radius: 20px;
        text-align: center;
        background-color: #1f5de3;
        background-image: linear-gradient(to right, #1f5de3, #1f85e3);
        font-size: 14px;
        font-weight: bold;
        color: #fefefe;
        cursor: pointer;
        display: inline-block;
        vertical-align: top;
      }
      .cancel-btn:hover,
      .open-btn:hover {
        cursor: pointer;
        opacity: 0.8;
      }

      .cancel-btn {
        margin: 0 auto;
        width: 120px;
        height: 41px;
        line-height: 41px;
        border-radius: 20px;
        text-align: center;
        background-color: #ededed;
        font-size: 14px;
        font-weight: bold;
        color: #666666;
        cursor: pointer;
        display: inline-block;
        vertical-align: top;
      }

      .btn-wrap {
        margin-top: 15px;
        text-align: center;
        .btn1,
        .btn2 {
          display: inline-block;
          width: 118px;
          height: 41px;
          line-height: 41px;
          border-radius: 58px;
          cursor: pointer;
        }
        .btn1 {
          background-color: #e6e6e6;
          font-size: 14px;
          color: #666666;
        }
        .btn2 {
          margin-left: 20px;
          background-color: #1f5de3;
          font-size: 14px;
          font-weight: bold;
          color: #fefefe;
        }
      }
    }
    .install2 {
      padding-top: 10px;
      margin-top: 110px;
      height: 242px;

      .icon1 {
        margin-top: 45px;
      }

      .text2 {
        margin-top: 14px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: #1a1a1a;
        line-height: 20px;
      }
      .speedshare-installing-btn {
        position: relative;
        margin: 0 auto;
        margin-top: 20px;
        width: 205px;

        .text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 9;
          font-size: 14px;
          font-weight: bold;
          color: #fefefe;
        }
      }
    }
    .install3 {
      .icon {
        margin: 0 auto;
        margin-top: 45px;
        width: 55px;
        height: 55px;
        background-image: url("../assets/speedShare/a7.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
        box-shadow: 0px 0px 20px 2px rgba(72, 103, 170, 0.24);
        border-radius: 50%;
      }
      .text2 {
        margin-top: 22px;
      }
      .open-btn {
        margin-top: 20px;
      }
    }
  }
}
</style>
<style lang="less">
.speedshare-installing-btn {
  .el-progress-bar {
    .el-progress-bar__outer {
      background-color: #1f5de3;
      border: none;
    }
  }
}
</style>
